import { ImportTemplateField } from "@/types";
import { DataType } from "../DataType";

export const HoldingWithInstrument: ImportTemplateField[] = [
  {
    toField: "holdingKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "instrumentKey",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "name",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "instrumentType",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "instrumentClass",
    fromField: "",
    dataType: DataType.string,
    required: true,
  },
  {
    toField: "round",
    fromField: "",
    dataType: DataType.integer,
    required: true,
  },
  {
    toField: "baseAmount", // Base amount of the transaction
    fromField: "",
    dataType: DataType.decimal,
    required: true, // Amount is required for valuation
    precision: 2, // Two decimal places for currency precision
  },
  {
    toField: "currency", // Currency of the transaction
    fromField: "",
    dataType: DataType.string,
    required: true, // Currency is required for proper accounting
  },
  {
    toField: "quantity", // Quantity of securities traded
    fromField: "",
    dataType: DataType.decimal,
    required: true, // Quantity is required for position calculations
    precision: 2, // Allow for fractional shares
  },
  {
    toField: "accountKey", // Account identifier
    fromField: "",
    dataType: DataType.string,
    required: true, // Account key is required to identify the account
  },
];
